import { render, staticRenderFns } from "./KeyMetrics.vue?vue&type=template&id=bc7da5c0&scoped=true"
import script from "./KeyMetrics.vue?vue&type=script&lang=js"
export * from "./KeyMetrics.vue?vue&type=script&lang=js"
import style0 from "./KeyMetrics.vue?vue&type=style&index=0&id=bc7da5c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc7da5c0",
  null
  
)

export default component.exports